import { useCallback, useEffect, useRef } from 'react';

interface FieldRefs {
  [key: string]: HTMLDivElement | null;
}

const hasErrorAtPath = (errors: Record<string, unknown>, path: string): boolean => {
  const parts = path.split('.');
  let current: unknown = errors;

  for (const part of parts) {
    if (!current || typeof current !== 'object') return false;

    const obj = current as Record<string, unknown>;
    current = obj[part];
  }

  return !!current;
};

export const useScrollToError = (errors: Record<string, unknown>) => {
  const fieldRefs = useRef<FieldRefs>({});

  const scrollToFirstError = useCallback(() => {
    if (!errors || Object.keys(errors).length === 0) return;

    const existingFields = Object.keys(fieldRefs.current).filter(
      (field) => fieldRefs.current[field] !== null,
    );

    const firstErrorField = existingFields.find((field) => hasErrorAtPath(errors, field));

    if (firstErrorField && fieldRefs.current[firstErrorField]) {
      fieldRefs.current[firstErrorField]?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [errors]);

  useEffect(() => {
    scrollToFirstError();
  }, [scrollToFirstError]);

  return fieldRefs;
};
